import { defineMessages } from "react-intl";

export const FormSubmittedMessageText = defineMessages({
  thankYou: {
    defaultMessage: "Thank You !!!",
    id: "favfFI",
  },
});
